<template>
  <div class="btn-group">
    <a :href="link" class="btn btn-warning btn-sm">Permisos</a>
  </div>
</template>
<script>
import Vue from "vue";
export default Vue.extend({
  computed: {
    link() {
      if (this.params && this.params.data && this.params.data.id_rol) {
        return `/#/admin/roles/${this.params.data.id_rol}`;
      }
      return "#";
    },
  },
});
</script>
